import CloseIcon from "@mui/icons-material/Close";
import { Chip } from "@mui/material";
import type React from "react";

export type BaseChipProps = {
  label: string;
  size: "small" | "medium";
  onDelete?: () => void;
};
export const BaseChip: React.FC<BaseChipProps> = (props) => {
  const { size, ...restProps } = props;
  return (
    <Chip
      variant="outlined"
      color="primary"
      sx={{
        backgroundColor: "white",
        height: size === "small" ? 28 : 40,
        fontSize: size === "small" ? 12 : 14,
        borderRadius: 999,
        paddingRight: 0.5,
        "& .MuiChip-deleteIcon": {
          fontSize: 18,
        },
      }}
      deleteIcon={<CloseIcon />}
      {...restProps}
    />
  );
};
